export default __webpack_public_path__ + "static/media/qr_bangsean_v3.cf02f0a5.png";